import { View, ScrollView, Pressable } from "react-native";
import { useNavigation } from "@react-navigation/native";
import type { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { ChevronRight } from "lucide-react-native";
import {
  colors,
  spacing,
  SCREEN_PADDING_TOP,
} from "@louise/moon-ui/theme/tokens";
import { MoonText } from "@louise/moon-ui/primitives/MoonText";
import GlassScreenLayout from "@louise/moon-ui/primitives/GlassScreenLayout";
import type { DevStackParamList } from "./DevNavigator";

type Nav = NativeStackNavigationProp<DevStackParamList>;

const SCREENS: {
  name: keyof DevStackParamList;
  label: string;
  description: string;
}[] = [
  {
    name: "DevComingSoon",
    label: "Coming Soon",
    description: "StatusBadge, ComingSoonOverlay, ComingSoonSheet",
  },
  {
    name: "DevComingSoonInventory",
    label: "Coming Soon Inventory",
    description: "All coming-soon features across the app, organized by area",
  },
  {
    name: "DevCoverageCardFixture",
    label: "Coverage Card Fixture",
    description: "Saved insurance card states using safe sample data",
  },
  {
    name: "DevFieldPlayground",
    label: "Field Playground",
    description:
      "MoonFormField, MoonNumericField, MoonCurrencyInput, MoonTimeField, MoonSelectField — every state",
  },
  {
    name: "DevFilterChipAudit",
    label: "Filter Chip Audit",
    description: "Hidden and legacy filter chip previews for visual audit",
  },
  {
    name: "DevButtonAudit",
    label: "Button Audit",
    description:
      "Current button/action families, reachable route links, and package-level cleanup queue",
  },
  {
    name: "DevPharmacyQuoteClaims",
    label: "Pharmacy Quote Claims Inspector",
    description:
      "Upload a pharmacy quote and dump the raw extraction claims + client projection",
  },
];

export default function DevHomeScreen() {
  const navigation = useNavigation<Nav>();

  return (
    <GlassScreenLayout>
      <ScrollView
        contentContainerStyle={{
          padding: spacing.lg,
          paddingTop: SCREEN_PADDING_TOP + spacing.lg,
          gap: spacing.lg,
          maxWidth: 390,
          width: "100%",
          alignSelf: "center",
        }}
      >
        <MoonText variant="display">Dev Components</MoonText>

        {SCREENS.map((screen) => (
          <Pressable
            key={screen.name}
            onPress={() => navigation.navigate(screen.name)}
            className="bg-moon-surface/80 flex-row items-center justify-between rounded-2xl p-4"
          >
            <View className="flex-1 gap-1">
              <MoonText variant="title">{screen.label}</MoonText>
              <MoonText variant="body-sm" color="textLight">
                {screen.description}
              </MoonText>
            </View>
            <ChevronRight size={18} color={colors.textFaint} />
          </Pressable>
        ))}
      </ScrollView>
    </GlassScreenLayout>
  );
}
